import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditFunctionType = ({
  show,
  onClose,
  initialFunctionType,
  initialDescription,
  id,
  onUpdated,
}) => {
  const [functionType, setFunctionType] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show) {
      setFunctionType(initialFunctionType || '');
      setDescription(initialDescription || '');
      setErrors({});
    }
  }, [show, initialFunctionType, initialDescription]);

  const validate = () => {
    const newErrors = {};
    if (!functionType.trim()) {
      newErrors.functionType = 'Function Type is required';
    }
    return newErrors;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${baseUrl}/functiontype/update_function/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          function_type: functionType,
          description: description,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update Function Type');
      }

      toast.success('Function Type updated successfully!');
      onClose(); 
      if (onUpdated) onUpdated();
    } catch (error) {
      console.error('Update Error:', error);
      toast.error('Failed to update Function Type');
    }
  };

  return (
    <>
      <Modal show={show} size="md" onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
            <h3 className="modal-title text-white">Update Function Type</h3>
            <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
              <span className="text-white">×</span>
            </Button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleUpdate}>
              <div className="row">
                <div className="col-lg-12 mb-2">
                  <label className="text-black font-w500 fs-7">
                    Function Type<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.functionType ? 'is-invalid' : ''}`}
                    placeholder="Enter Function Type"
                    value={functionType}
                    onChange={(e) => setFunctionType(e.target.value)}
                  />
                  {errors.functionType && (
                    <div className="invalid-feedback" style={{ display: 'block' }}>
                      {errors.functionType}
                    </div>
                  )}
                </div>
                <div className="col-lg-12 mb-2">
                  <label className="text-black font-w500 fs-7">Description</label>
                  <textarea
                    rows={4}
                    className="form-control h-auto"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                <Button type="submit" className="btn btn-sm btn-primary">
                  Update Function Type
                  <i className="fas fa-angle-double-right ms-2"></i>
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default EditFunctionType;
